import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Solutions } from './components/Solutions';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Solutions data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <PricingOffer variant="primary" data-id="element-7" />
        <BonusSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <PricingOffer variant="secondary" data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}